import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { reset } from 'redux-form';
import { loadMessageTemplates, deleteMessageTemplate } from './actions';
import List from './List';
import Filter from './Filter';
import authUtils from '../../auth/utils';

class MessageTemplates extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleFilterReset() {
		this.handleFilterSubmit({});
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	handleDelete(id) {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.props.deleteMessageTemplate(id, () => this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }));
	}

	render() {
		const { isReadonly, enableCustomTemplates } = this.props;
		return (
			<div>
				<Filter enableCustomTemplates={enableCustomTemplates} onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} loading={this.props.pagination.loading} />
				<List isReadonly={isReadonly} enableCustomTemplates={enableCustomTemplates} onFetchData={this.handleListEvent} onDelete={this.handleDelete} data={this.props.data} {...this.props.pagination} />
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		entities: { messageTemplates },
		auth: { currentUser },
		configuration: { franchisor }
	} = state;

	const messageTemplatesPagination = pagination.messageTemplates.all || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: messageTemplatesPagination.ids.map(id => messageTemplates[id]),
		pagination: messageTemplatesPagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'MessageTemplates'),
		enableCustomTemplates: franchisor.enableAdHocMessages
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadMessageTemplates,
	deleteMessageTemplate: deleteMessageTemplate,
	resetFilter: () => reset('messageTemplatesFilter'),
	initializeFilter: (data, fields) => initialize('messageTemplatesFilter', data, fields)
})(MessageTemplates);